/* eslint-disable no-secrets/no-secrets */
/* eslint-disable security/detect-object-injection */
import React, { useEffect, useState, useContext, useCallback } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import appConfig from 'app-config';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import {Identify} from '../../../../capabilities-react/gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent'

import metadata from './ActivityReportsComponent.metadata.json5';
import styles from './ActivityReportsComponent.module.scss';
import { messages } from '@jutro/legacy/datatable/DataTable.messages';

import { IntlContext } from '@jutro/legacy/locale';

const CONSUMER_POLICY_CHANGE_REPORT = 'consumer-policy-change-report';
const PRODUCER_POLICY_CHANGE_REPORT = 'producer-policy-change-report';
const POLICY_CHANGES_REPORT = 'policy-changes-report';
const RENEWALS_REPORT = 'renewals-report';
const CLAIMS_REPORT = 'claims-report';
const DELINQUENTS_REPORT = 'delinquents-report';
const FOLLOW_UPS_REPORT = 'followups-report';
const CANCELLATIONS_REPORT = 'cancellations-report';
const TASKS_REPORT = 'tasks-report';
const INCOMPLETE_PENDED_REPORT = 'incomplete-pended-report';
const CONTINGENCIES_REPORT = 'contingencies-report';
const MIGRATIONS_REPORT = 'migrations-report';
const QUOTES_REPORT = 'quotes-report';
const PAYMENT_LOG = 'payment-log';

const reportBtnMapping = {
    consumerPolicyChangeReportBtn: CONSUMER_POLICY_CHANGE_REPORT,
    producerPolicyChangeReportBtn: PRODUCER_POLICY_CHANGE_REPORT,
    policyChangesReportBtn: POLICY_CHANGES_REPORT,
    renewalsReportBtn: RENEWALS_REPORT,
    claimsReportBtn: CLAIMS_REPORT,
    delinquentsReportBtn: DELINQUENTS_REPORT,
    followUpsReportBtn: FOLLOW_UPS_REPORT,
    cancellationsReportBtn: CANCELLATIONS_REPORT,
    tasksReportBtn: TASKS_REPORT,
    incompletePendedReportBtn: INCOMPLETE_PENDED_REPORT,
    contingenciesReportBtn: CONTINGENCIES_REPORT,
    migrationsReportBtn: MIGRATIONS_REPORT,
    quotesReportBtn: QUOTES_REPORT,
    paymentLogReportBtn: PAYMENT_LOG
};

function ActivityReportsComponent(props) {
    const { isDashboard, rowLimit, selectedView, authUserData, viewModelService } = props;
    const { MLUserTypes } = appConfig;
    const intl = useContext(IntlContext);
    const translator = useTranslator();

    const initialCurrentView = () => {
        const userType = authUserData.userType;
        if (userType === MLUserTypes.IA || userType === MLUserTypes.PCS || userType === MLUserTypes.MET_GA) {
            return POLICY_CHANGES_REPORT;
        }
        return FOLLOW_UPS_REPORT;
    }
    const [currentView, updateCurrentView] = useState(selectedView || initialCurrentView());

    const isPCS = () => {
        return authUserData.userType === MLUserTypes.PCS;
    };

    const isIA = () => {
        return authUserData.userType === MLUserTypes.IA;
    };

    const isMetGA = () => {
        return authUserData.userType === MLUserTypes.MET_GA;
    };

    const isGCSSales = () => {
        return authUserData.userType === MLUserTypes.GCS_SALES;
    };

    const isGCSServicing = () => {
        return authUserData.userType === MLUserTypes.GCS_SERVICING;
    };

    const getCustomerDisplayNameRevert = useCallback((accountHolder) => {
        if (accountHolder) {
            let result = accountHolder.lastName || '-';
            result += `, `;

            if (accountHolder.firstName) {
                result += ` ${accountHolder.firstName}`;
            }

            if (accountHolder.middleName) {
                result += ` ${accountHolder.middleName}`;
            }

            if (accountHolder.suffix) {
                const suffixTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix');
                const suffixName = suffixTypelist.getCode(accountHolder.suffix).name;
                const suffix = translator({
                    id: suffixName,
                    defaultMessage: suffixName
                });
                result += ` ${suffix}`;
            }

            return result;
        }

        return '-';
    }, [translator, viewModelService.productMetadata]);

    const formatAmountString = useCallback((amount) => {
        const premium = _.get(amount, 'amount', 0);
        const currency = _.get(amount, 'currency', 'usd');

        try {
            return intl.formatNumber(premium, { style: 'currency', currency });
        } catch (e) {
            return '';
        }
    }, [intl]);

    const getCustomerDisplayName = (accountHolder) => {
        if (accountHolder) {
            let result = accountHolder.firstName || '-';

            if (accountHolder.middleName) {
                result += `, ${accountHolder.middleName}`;
            }

            if (accountHolder.lastName) {
                result += `, ${accountHolder.lastName}`;
            }

            if (accountHolder.suffix) {
                const suffixTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix');
                const suffixName = suffixTypelist.getCode(accountHolder.suffix).name;
                const suffix = translator({
                    id: suffixName,
                    defaultMessage: suffixName
                });
                result += `, ${suffix}`;
            }

            return result;
        }

        return '-';
    };

    const convertLocalDateToDate = (localDate) => {
        const parsedDate = new Date(localDate.year, localDate.month, localDate.day);
        return moment(parsedDate).format('MM/DD/YYYY');
    };

    const getButtonClassName = (buttonName) => {
        return currentView === buttonName ? "ml-btn ml-btn-default active" : "ml-btn ml-btn-default";
    }

    useEffect(() => {
        if (!isDashboard) {
            Identify('Activity Report Screen Reached', {step: currentView}, null)
        }
    }, [])

    // Add keyboard event listener for tabs
    useEffect(() => {
        const tabList = document.getElementById('activityReportsButtonContainer');

        if(tabList) {
            tabList.onkeydown = (e) => {
                if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
                    const tabs = tabList.querySelectorAll(':scope > [role="tab"]');
                    const tabsArray = Array.from(tabs);

                    let tabFocus = tabsArray.findIndex((el) => {
                        return document.activeElement.id === el.id;
                    });

                    if (e.key === "ArrowRight") {
                        tabFocus++;

                        // If we're at the end, go to the start
                        if (tabFocus >= tabs.length) {
                            tabFocus = 0;
                        }
                        // Move left
                    } else if (e.key === "ArrowLeft") {
                        tabFocus--;

                        // If we're at the start, move to the end
                        if (tabFocus < 0) {
                            tabFocus = tabs.length - 1;
                        }
                    }

                    tabs[tabFocus].focus();
                }
            }
        }
    });

    const overrides = {
        activityReportSection: {
            className: isDashboard ? "" : "ml-section overlapped"
        },
        activityReportsButtonContainer: {
            className: isDashboard ? "btn-group vertical-spacing-15" : "btn-group",
            'aria-label': 'Activity Reports',
            role: 'tablist'
        },
        activityReportsRow: {
            className: isDashboard ? "row col-md-12 activityReportsRow" : "row col-md-12 activityReport"
        },
        consumerPolicyChangeReportBtn: {
            visible: false,
            className: getButtonClassName(CONSUMER_POLICY_CHANGE_REPORT),
            mlTagManagerLinkClick: "Dashboard_activityReport_customerChanges",
            'aria-selected': currentView === CONSUMER_POLICY_CHANGE_REPORT,
            tabindex: (currentView === CONSUMER_POLICY_CHANGE_REPORT) ? '0' : '-1',
            role: 'tab'
        },
        producerPolicyChangeReportBtn: {
            visible: false,
            className: getButtonClassName(PRODUCER_POLICY_CHANGE_REPORT),
            mlTagManagerLinkClick: "Dashboard_activityReport_agentChanges",
            'aria-selected': currentView === PRODUCER_POLICY_CHANGE_REPORT,
            tabindex: (currentView === PRODUCER_POLICY_CHANGE_REPORT) ? '0' : '-1',
            role: 'tab'
        },
        policyChangesReportBtn: {
            visible: isPCS() || isIA() || isMetGA(),
            className: getButtonClassName(POLICY_CHANGES_REPORT),
            mlTagManagerLinkClick: "Dashboard_activityReport_policyChanges",
            'aria-selected': currentView === POLICY_CHANGES_REPORT,
            tabindex: (currentView === POLICY_CHANGES_REPORT) ? '0' : '-1',
            role: 'tab'
        },
        renewalsReportBtn: {
            visible: isPCS() || isIA() || isMetGA(),
            className: getButtonClassName(RENEWALS_REPORT),
            mlTagManagerLinkClick: "Dashboard_activityReport_renewals",
            'aria-selected': currentView === RENEWALS_REPORT,
            tabindex: (currentView === RENEWALS_REPORT) ? '0' : '-1',
            role: 'tab'
        },
        claimsReportBtn: {
            visible: isPCS() || isIA() || isMetGA(),
            className: getButtonClassName(CLAIMS_REPORT),
            mlTagManagerLinkClick: "Dashboard_activityReport_claims",
            'aria-selected': currentView === CLAIMS_REPORT,
            tabindex: (currentView === CLAIMS_REPORT) ? '0' : '-1',
            role: 'tab'
        },
        delinquentsReportBtn: {
            visible: isPCS() || isIA() || isMetGA(),
            className: getButtonClassName(DELINQUENTS_REPORT),
            mlTagManagerLinkClick: "Dashboard_activityReport_billing&cancels",
            'aria-selected': currentView === DELINQUENTS_REPORT,
            tabindex: (currentView === DELINQUENTS_REPORT) ? '0' : '-1',
            role: 'tab'
        },
        migrationsReportBtn: {
            // TODO: replace with isIA || PCS when migration is implemented for future release
            visible: false,
            className: getButtonClassName(MIGRATIONS_REPORT),
            mlTagManagerLinkClick: "Dashboard_activityReport_migrations",
            'aria-selected': currentView === MIGRATIONS_REPORT,
            tabindex: (currentView === MIGRATIONS_REPORT) ? '0' : '-1',
            role: 'tab'
        },
        followUpsReportBtn: {
            visible: isGCSSales() || isGCSServicing(),
            className: getButtonClassName(FOLLOW_UPS_REPORT),
            mlTagManagerLinkClick: "Dashboard_activityReport_myFollowUps",
            'aria-selected': currentView === FOLLOW_UPS_REPORT,
            tabindex: (currentView === FOLLOW_UPS_REPORT) ? '0' : '-1',
            role: 'tab'
        },
        tasksReportBtn: {
            visible: isGCSSales() || isGCSServicing(),
            className: getButtonClassName(TASKS_REPORT),
            mlTagManagerLinkClick: "Dashboard_activityReport_tasks",
            'aria-selected': currentView === TASKS_REPORT,
            tabindex: (currentView === TASKS_REPORT) ? '0' : '-1',
            role: 'tab'
        },
        cancellationsReportBtn: {
            visible: isGCSSales(),
            className: getButtonClassName(CANCELLATIONS_REPORT),
            mlTagManagerLinkClick: "Dashboard_activityReport_cancellations",
            'aria-selected': currentView === CANCELLATIONS_REPORT,
            tabindex: (currentView === CANCELLATIONS_REPORT) ? '0' : '-1',
            role: 'tab'
        },
        incompletePendedReportBtn: {
            visible: isGCSServicing(),
            className: getButtonClassName(INCOMPLETE_PENDED_REPORT),
            mlTagManagerLinkClick: "Dashboard_activityReport_incompletePendedReport",
            'aria-selected': currentView === INCOMPLETE_PENDED_REPORT,
            tabindex: (currentView === INCOMPLETE_PENDED_REPORT) ? '0' : '-1',
            role: 'tab'
        },
        quotesReportBtn: {
            visible: isGCSSales() || isPCS() || isIA()  || isMetGA(),
            className: getButtonClassName(QUOTES_REPORT),
            mlTagManagerLinkClick: "Dashboard_activityReport_quotes",
            'aria-selected': currentView === QUOTES_REPORT,
            tabindex: (currentView === QUOTES_REPORT) ? '0' : '-1',
            role: 'tab'
        },
        contingenciesReportBtn: {
            visible: isPCS() || isIA() || isMetGA(),
            className: getButtonClassName(CONTINGENCIES_REPORT),
            mlTagManagerLinkClick: "Dashboard_activityReport_contingencies",
            'aria-selected': currentView === CONTINGENCIES_REPORT,
            tabindex: (currentView === CONTINGENCIES_REPORT) ? '0' : '-1',
            role: 'tab'
        },
        paymentLogReportBtn: {
            visible: isPCS() || isIA() || isMetGA(),
            className: getButtonClassName(PAYMENT_LOG),
            mlTagManagerLinkClick: "Dashboard_activityReport_payment_log",
            'aria-selected': currentView === PAYMENT_LOG,
            tabindex: (currentView === PAYMENT_LOG) ? '0' : '-1',
            role: 'tab'
        },
        consumerPolicyChangeReport: {
            showAgentChanges: currentView === PRODUCER_POLICY_CHANGE_REPORT,
            showAllChanges: currentView === POLICY_CHANGES_REPORT,
            isDashboard,
            rowLimit,
            getCustomerDisplayNameRevert,
            isCompactView: isDashboard,
            visible: currentView === CONSUMER_POLICY_CHANGE_REPORT
        },
        producerPolicyChangeReport: {
            showAgentChanges: currentView === PRODUCER_POLICY_CHANGE_REPORT,
            showAllChanges: currentView === POLICY_CHANGES_REPORT,
            isDashboard,
            rowLimit,
            getCustomerDisplayNameRevert,
            isCompactView: isDashboard,
            visible: currentView === PRODUCER_POLICY_CHANGE_REPORT
        },
        policyChangesReport: {
            showAgentChanges: currentView === PRODUCER_POLICY_CHANGE_REPORT,
            showAllChanges: currentView === POLICY_CHANGES_REPORT,
            isDashboard,
            rowLimit,
            getCustomerDisplayNameRevert,
            isCompactView: isDashboard,
            visible: currentView === POLICY_CHANGES_REPORT
        },
        renewalsReport: {
            isDashboard,
            rowLimit,
            getCustomerDisplayNameRevert,
            isCompactView: isDashboard,
            formatAmountString,
            visible: currentView === RENEWALS_REPORT
        },
        claimsReport: {
            isDashboard,
            rowLimit,
            getCustomerDisplayNameRevert,
            isCompactView: isDashboard,
            visible: currentView === CLAIMS_REPORT,
            convertLocalDateToDate
        },
        delinquentsReport: {
            isDashboard,
            rowLimit,
            getCustomerDisplayNameRevert,
            isCompactView: isDashboard,
            visible: currentView === DELINQUENTS_REPORT,
            convertLocalDateToDate
        },
        followUpsReport: {
            isDashboard,
            rowLimit,
            isCompactView: isDashboard,
            visible: currentView === FOLLOW_UPS_REPORT,
            filterBy: 'user',
            convertLocalDateToDate
        },
        tasksReport: {
            isDashboard,
            rowLimit,
            isCompactView: isDashboard,
            visible: currentView === TASKS_REPORT,
            filterBy: 'other',
            convertLocalDateToDate
        },
        cancellationsReport: {
            isDashboard,
            rowLimit,
            getCustomerDisplayNameRevert,
            isCompactView: isDashboard,
            visible: currentView === CANCELLATIONS_REPORT,
            convertLocalDateToDate
        },
        incompletePendedReport: {
            isDashboard,
            rowLimit,
            getCustomerDisplayNameRevert,
            isCompactView: isDashboard,
            visible: currentView === INCOMPLETE_PENDED_REPORT,
            convertLocalDateToDate
        },
        contingenciesReport: {
            isDashboard,
            rowLimit,
            getCustomerDisplayNameRevert,
            isCompactView: isDashboard,
            visible: currentView === CONTINGENCIES_REPORT,
            convertLocalDateToDate
        },
        migrationsReport: {
            visible: currentView === MIGRATIONS_REPORT,
            isDashboard,
            rowLimit
        },
        quotesReport: {
            visible: currentView === QUOTES_REPORT,
            moreDetails: !isDashboard,
            convertLocalDateToDate,
            formatAmountString,
            isDashboard
        },
        paymentLogReport: {
            isDashboard,
            rowLimit,
            getCustomerDisplayNameRevert,
            isCompactView: isDashboard,
            visible: currentView === PAYMENT_LOG,
            convertLocalDateToDate,
            formatAmountString
        }
    };

    const handleOnClick = (prop) => {
        updateCurrentView(reportBtnMapping[prop.currentTarget.id]);

        if (!isDashboard) {
            Identify('Activity Report Screen Reached', {step:reportBtnMapping[prop.currentTarget.id] }, null)
        }
    }

    const resolvers = {
        resolveCallbackMap: {
            handleOnClick
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

ActivityReportsComponent.propTypes = {
    isDashboard: PropTypes.bool,
    rowLimit: PropTypes.number
};

ActivityReportsComponent.defaultProps = {
    isDashboard: false,
    rowLimit: 0
}

export default withRouter(withAuthenticationContext(withViewModelService(ActivityReportsComponent)));